<template>
  <div class="menubar">
    <div class="menubar__left">
      <div class="menubar__left__logo">
        <adx-sidebar />
        <router-link to="/">
          <img class="menubar__left__logo--responsive" src="/img/adx/adx-red.png" alt="">
        </router-link>
      </div>
      <div class="menubar__left__search">
        <adx-search />
      </div>
    </div>
    <div class="menubar__right">
      <div class="menubar__right__menu">
        <ul>
          <router-link v-for="(menu, index) in mainmenus" tag="li" :key="index" class="menubar__right__menu__item" :to="{name: menu.link}" v-if="checkLogin(menu.isLogin)">{{menu.title}}</router-link>
          <template v-if="!isLogin && isAccountpage">
            <li class="menubar__right__menu__item" @click="signin">
              Sign In
            </li>
          </template>
          <template v-else-if="isLogin">
            <li class="menubar__right__menu__item profile" @click.stop="openSubMenu">
              <div class="icon-profile" :class="{ active: isSubmenu }">
                <template v-if="this.$store.getters.profileImage">
                  <img :src="this.$store.getters.profileImage" alt="">
                </template>
                <template v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 16 16">
                      <defs>
                          <path id="a" d="M2.928 9.945c.14-.12.285-.243.45-.344.129-.08.502-.2.643-.239.23-.063.57-.093.668-.351 0 0 .132-.515.078-1.212 0 0-.516-.062-.462-1.256 0 0-.327.271-.405-.404 0 0-.085-.465-.147-.55 0 0-.172-.457.14-.396 0 0-.055-.899-.094-1.1a1.576 1.576 0 0 1 .017-.549c.027-.15.074-.3.16-.428.099-.147.274-.215.412-.316.177-.13.346-.274.535-.385.075-.044.152-.085.23-.121.044-.02.235-.056.258-.086 0 0 .07-.093.218-.093a3.127 3.127 0 0 1 .9.088c.17.046.342.133.508.197.122.047.238.108.346.183.316.22.492.534.542.912 0 0 .101.76-.132 1.644 0 0 .42-.217.132.69 0 0-.077.272-.093.419 0 0-.023.388-.32.202 0 0 .024 1.287-.396 1.341 0 0-.047 1.171.226 1.295 0 0 .256.194 1.105.357 0 0 .4.168.812.349a5 5 0 1 0-6.331.153zM6 12A6 6 0 1 1 6 0a6 6 0 0 1 0 12z"/>
                      </defs>
                      <use fill="#262626" fill-rule="evenodd" transform="translate(2 2)" xlink:href="#a"/>
                  </svg>
                </template>
                <div class="submenu__profile" v-if="isSubmenu">
                  <div class="submenu__profile__item" @click="goToProfile">My Account</div>
                  <div class="submenu__profile__item" @click="goToDashboard">Dashboard</div>
                  <div class="submenu__profile__item" @click="signout">Sign Out</div>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="menubar__mobile" v-if="isShowFooter">
      <ul>
        <router-link :class="{active : checkrouteActive(menu.link)}" v-for="(menu, index) in footmenus" :key="index" class="menubar__mobile__item" :to="{name: menu.link}">
          <i :class="menu.icon"></i>
          <span>{{menu.title}}</span>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import Sidebar from '@/components/SideBar/Mobile'
import Search from '@/components/Search'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-menubar',
  components: {
    'adx-sidebar': Sidebar,
    'adx-search': Search
  },
  props: {
    showFooterMobile: {
      required: false,
      default: true
    }
  },
  data() {
    return {
      mainmenus: [],
      footmenus: [],
      isSubmenu: false,
    }
  },
  computed: {
    isShowFooter() {
      if (this.showFooterMobile) {
        return true
      }

      return false
    },
    isLogin() {
      if(this.$store.state.account.token){
        const isSuperuser = this.$store.getters.isSuperuser
        const isStaff = this.$store.getters.isStaff
        const groups = this.$store.getters.groups.split(',')
        if (!isSuperuser && !isStaff && groups.includes('Pertamina')) {
          this.isShowFooter = false
        }
        return true
      }else {
        return false
      }
      // return this.$store.state.account.token
    },
    isAccountpage() {
      if(this.$route.name == 'signin' || this.$route.name == 'signup' || this.$route.name == 'forgot'){
        return false
      }else {
        return true
      }
    }
  },
  created() {
    (async () => {
      let file = `/static/data/menus.json`
      let request = await fetch(new Request(file))
      let data = await request.json()

      this.footmenus = data.footmenus
      this.mainmenus = data.mainmenus
    })();

    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeSubMenu.bind(this))
    })
  },
  methods: {
    checkrouteActive(link) {
      const path = this.$route.path
      const isDashboard = /dashboard/.test(path)
      if(isDashboard && link == 'dashboard'){
        return true
      }
      return false
    },
    signin() {
      Vue.$broker.$emit("openSignin");
    },
    signup() {
      Vue.$broker.$emit("openSignup");
    },
    signout() {
      (async () => {
        const responseStatus = await api.post(apiV2.signout, {}, { needToken: true })
        const response  = await this.$store.dispatch('removeAccount')
        this.$auth.logout()

        window.location.reload()
      })();
    },
    goToDashboard() {
      this.$router.push({name:'dashboard'})
    },
    goToProfile() {
      this.$router.push({name:'editprofile'})
    },
    openSubMenu() {
      this.isSubmenu = !this.isSubmenu
    },
    closeSubMenu(sender) {
      if (sender === this) {
        return
      }
      this.isSubmenu = false
    },
    checkLogin(isLogin) {
      const token = this.$store.getters.token
      const isSuperuser = this.$store.getters.isSuperuser
      const staff = this.$store.getters.isStaff
      const groups = this.$store.getters.groups.split(',')
      if(isLogin == true && token) {
        return true
      }else if(isLogin == true && token == '') {
        return false
      }else if(isLogin == "superuser" && !isSuperuser) {
        return false
      } else if (isLogin == "collection") {
        if (isSuperuser) {
          return true
        } else if (staff && groups.includes('Admin Collection')) {
          return true
        } else {
          return false
        }
      } else if (isLogin == "Pertamina") {
        if (isSuperuser) {
          return true
        } else if (groups.includes('Pertamina')) {
          return true
        } else {
          return false
        }
      } else if (isLogin == "admin_bus") {
        if (isSuperuser) {
          return true
        } else if (groups.includes('admin_bus')) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/base";
</style>


<style lang='scss' scoped>
@import './index.scss';
</style>